import { createSlice } from '@reduxjs/toolkit';
import {
  getSearchJobList,
  getSearchUsersList,
} from 'redux/services/SearchService';

export const SearchSlice = createSlice({
  name: 'search',
  initialState: {
    // searchUsersList: {},
  },
  reducers: {
    // setSearchUsersList: (state, action) => {
    //   state.searchUsersList = action.payload;
    // },
  },
});

export const handleGetSearchUsersList = (payload) => async () => {
  return getSearchUsersList(payload);
};

export const handleGetSearchJobList = (payload) => async () => {
  return getSearchJobList(payload);
};

// export const {} = SearchSlice.actions;
export default SearchSlice.reducer;
